// @ts-nocheck
import { FieldsDictionary } from "@store/Framework/Features/FieldDefinitionBuilder/FieldDefinitionBuilderTypes";

export default <TOptions>(fieldDictionary: FieldsDictionary, options?: TOptions): Toolkit.FieldDefinition[] => {
    if (!options) {
        return [];
    }

    const fieldDefinition: Toolkit.FieldDefinition[] = [];

    for (const key in options) {
        const option = (options as any)[key];

        if (option) {
            const field = fieldDictionary[key];

            fieldDefinition.push(field as Toolkit.FieldDefinition);
        }
    }

    return fieldDefinition;
};
